import React from "react";
import { Image } from "@wss/image";
import LinkTile from "./LinkTile";
const Specials = () => {
  return <div className="bg-gray-50 rounded" data-testid="ways-to-save-specials" data-sentry-component="Specials" data-sentry-source-file="Specials.tsx">
      <div className="w-full h-auto lg:max-h-40 flex justify-center items-center">
        <a href="/specials.html" className="relative flex flex-1 justify-center items-center group">
          <p className="absolute z-10 flex flex-col text-center mb-0">
            <span className="text-2xl font-normal text-black leading-none">
              Limited&nbsp;Time
            </span>
            <span className="font-bold text-black leading-none text-[56px] -mt-1">
              Sales
            </span>
          </p>
          <Image src="/uploads/design/2024/4/Deals-Image-Update/limited-time-deals-bg.jpg" alt="" loading="lazy" className="relative rounded-t w-full h-auto group-hover:opacity-90 transition-all ease-in-out duration-75 lg:max-h-40" width={20} height={9} data-sentry-element="Image" data-sentry-source-file="Specials.tsx" />
        </a>
      </div>
      <LinkTile link="/specials.html" linkText="Shop Sales" description=" Discover new sales daily" data-sentry-element="LinkTile" data-sentry-source-file="Specials.tsx" />
    </div>;
};
export default Specials;